import type { Address } from '@montugroup/circuit-shared/types/address';
import type { ArrayElement } from '@montugroup/circuit-shared/utils/typscript-helpers';
import { useMemo } from 'react';
import type { DeliveryOptions } from './types';
import useDeliveryOptions from './useDeliveryOptions';

export type ClickAndCollectOption = ArrayElement<DeliveryOptions['ClickAndCollect']>;

export type ClickAndCollectSelection =
  | { isFetching: true }
  | { isFetching: false; isNegotiable: true; options: ClickAndCollectOption[] }
  | { isFetching: false; isNegotiable: false; option: ClickAndCollectOption };

export default function useClickAndCollectSelection({
  addressOverride,
}: { addressOverride?: Address } = {}): ClickAndCollectSelection {
  const { deliveryOptions, isFetching } = useDeliveryOptions({ addressOverride });

  return useMemo<ClickAndCollectSelection>(() => {
    if (isFetching) {
      return { isFetching: true };
    }

    const options = deliveryOptions.ClickAndCollect;
    const nonNegotiableOption = options.find((option) => option.negotiable === false);

    if (nonNegotiableOption) {
      return { isFetching: false, isNegotiable: false, option: nonNegotiableOption };
    }

    return { isFetching: false, isNegotiable: true, options };
  }, [deliveryOptions, isFetching]);
}
